import { createSlice } from '@reduxjs/toolkit';
import initialState from './referralSourcesFormInitialState';
import {
  _setNewReferralSourceForm,
  _setOrgId,
} from './referralSourcesFormActions';

export const referralSourcesFormSlice = createSlice({
  name: 'getReferralSource',
  initialState,
  reducers: {
    getReferralSource: (state, action) => action.payload,
    setNewReferralSourceForm: _setNewReferralSourceForm,
    setOrgId: _setOrgId,
    resetReferralSource: (state) => initialState,
  },
});

export const {
  getReferralSource,
  setNewReferralSourceForm,
  setOrgId,
  resetReferralSource,
} = referralSourcesFormSlice.actions;

export default referralSourcesFormSlice.reducer;
